import {Component, OnInit, Input, HostBinding, OnDestroy, EventEmitter, Output, ElementRef} from '@angular/core';
import {TasksService} from '../../../../../data/tasks/tasks.service';
import moment from 'moment';
import {
  ProjectWindowComponent
} from 'projects/desktop/src/app/modules/project/view/project-window/project-window.component';
import {ProjectInfoComponent} from 'projects/mobile/src/app/modules/project/view/project-info/project-info.component';
import {DeviceDetectorService} from 'ngx-device-detector';
import {MatDialog} from '@angular/material/dialog';
import {WsUpdateResponce} from 'projects/app-misc/src/app/modules/data/ws-update-responce';
import {WsService} from 'projects/app-misc/src/app/modules/data/ws.service';
import {EntityTask} from '../../../../../data/tasks/entity-task';
import {filter, takeUntil} from 'rxjs/operators';
import {ShortTask} from '../../../../../data/tasks/short-task';
import {Task} from '../../../../../data/tasks/task';
import {TaskCheckItem} from '../../../../../data/tasks/task-checkitem';
import {ProjectService} from 'projects/app-misc/src/app/modules/project-misc/data/project/project.service';
import {CheckItemHeadTag} from 'projects/app-misc/src/app/modules/trello-misc/data/checkitem-head-tag';
import {TrelloService} from 'projects/app-misc/src/app/modules/trello-misc/data/trello.service';
import {AppStateQuery} from 'projects/desktop/src/app/data/app-state.query';
import {User} from 'projects/core/src/lib/login/data/user';
import {Subject, Subscription} from 'rxjs';
import {RxJSUnsubscribable} from 'projects/core/src/lib/core/utils/interfaces/rxjs-unsubscribable';
import {RxJSUnsubscribe} from 'projects/core/src/lib/core/utils/decorators/rxjs-unsubscribe-decorator';
import {ProjectFile} from 'projects/app-misc/src/app/modules/project-misc/data/project/project-file';
import {ConfirmationService} from 'primeng/api';
import {HttpEventType, HttpResponse} from '@angular/common/http';
import {FileOpenerService} from 'projects/app-misc/src/app/modules/project-misc/utils/fileOpener.service';
import {FileService} from 'projects/core/src/lib/misc/data/file/file.service';

@Component({
  selector: 'app-task-card',
  templateUrl: './task-card.component.html',
  styleUrls: ['./task-card.component.scss'],
  providers: [DeviceDetectorService, ConfirmationService]
})
@RxJSUnsubscribe
export class TaskCardComponent implements OnInit, OnDestroy, RxJSUnsubscribable {

  @Input()
  task: ShortTask;

  @Input()
  showFrom: boolean;

  @Input()
  fromProj: boolean;

  @Input()
  toggleOrders: boolean;

  @Input()
  workOrder: boolean;

  @Input()
  showCollapseButton = false;

  @Input()
  projectTask = false;

  @Input()
  isCollapsed = true;

  @Output()
  workOrderToggle = new EventEmitter<any>();

  @Output()
  collapseToggle = new EventEmitter<void>();

  @HostBinding('class.status-ready')
  taskCompleted: boolean;

  isMobile = false;
  isTablet = false;

  isLate = false;

  currentUser: User;

  @Output()
  emitCollapseOff = new EventEmitter<number>();

  statusString: string;
  classString: string;
  iconString: string;

  wsSub: Subscription
  serviceDep: boolean;

  choosenCheckItem: TaskCheckItem;

  loadingSpinnerId: number;

  constructor(
    protected fileService: FileService,
    protected fileOpenerService: FileOpenerService,
    protected el: ElementRef,
    protected dialog: MatDialog,
    protected wsService: WsService,
    protected trelloService: TrelloService,
    protected tasksService: TasksService,
    protected projectService: ProjectService,
    protected confirmationService: ConfirmationService,
    protected deviceDetectorService: DeviceDetectorService,
    protected appStateQuery: AppStateQuery
  ) {
  }

  ngOnInit(): void {
    this.appStateQuery.currentUser$.subscribe(user => {
      this.currentUser = user
      this.serviceDep = !!this.currentUser.roles.find(role => role.name === 'Service Department')
    })

    if (this.task.completed) {
      this.taskCompleted = true;
    }

    this.trelloService.checkItemLoading$.subscribe(emit => {
      this.loadingSpinnerId = emit
    })

    this.fillNames();

    this.isMobile = this.deviceDetectorService.isMobile();
    this.isTablet = this.deviceDetectorService.isTablet();

    this.subToSocket();

    this.checkLate();

    this.countProgress()

    if (this.task.clazz === 'SERVICE_ORDER_TASK') {
      this.checkStatus()
    }
    this.isCollapsed = this.isCollapsedByDefault();
  }

  checkStatus() {
    if (this.task.creationNfsStatus === 'Created' || this.task.dateMoveNfsStatus === 'Created') {
      this.statusString = 'Client Not Notified';
      this.classString = 'orange-icon'
      this.iconString = 'schedule_send'
    } else if (this.task.creationNfsStatus === 'Resolved' || this.task.dateMoveNfsStatus === 'Resolved') {
      this.statusString = 'Client Notified';
      this.classString = 'green-icon'
      this.iconString = 'mark_email_read'
    }
  }

  fillNames() {
    if (this.task.assignedUserName) {
      let name = this.task.assignedUserName

      let letters = name.split(' ');
      if (letters.length > 1) {
        this.task.shortAssigned = letters[0] + ' ' + letters[1].split('')[0] + '.'
      } else {
        this.task.shortAssigned = letters[0];
      }

      name = this.task.authorName
      letters = name.split(' ');
      if (letters.length > 1) {
        this.task.shortAuthor = letters[0] + ' ' + letters[1].split('')[0] + '.'
      } else {
        this.task.shortAuthor = letters[0];
      }
    }
  }

  countProgress() {
    // this.task.progressBarNum = (this.task.checkitemsCompleted * 100) / this.task.checkitemsTotal;
    // if (this.task.progressBarNum <= 33) {
    // 	this.task.colorNum = 'low-progress';
    // }
    // else if (this.task.progressBarNum > 33 && this.task.progressBarNum <= 66) {
    // 	this.task.colorNum = 'middle-progress';
    // }
    // else if (this.task.progressBarNum > 66 && this.task.progressBarNum <= 100) {
    // 	this.task.colorNum = 'high-progress';
    // }
  }

  subToSocket() {
    this.wsSub = this.wsService
      .listenUntilDestroyed<WsUpdateResponce<EntityTask>>('/topic/update/model.comment.TaskComment', this)
      .pipe(
        filter(updateInfo => {
          if (updateInfo.entity.task && updateInfo.entity.task.id === this.task.id) {
            return true
          }
          return false
        }),
        takeUntil(this.getUnsubFromAllSubs())
      )
      .subscribe(updateInfo => {
        this.tasksService.getShortTask(this.task.id).subscribe(newTask => {
          this.task = newTask
          this.fillNames();
          this.countProgress()
        });
      })
  }

  toggleTask(event) {
    event.stopPropagation();


    if (this.task.completed) {
      this.task.completed = null;
      this.taskCompleted = false;
    } else {
      this.task.completed = moment().toDate();
      this.taskCompleted = true;
    }

    this.tasksService.updateTaskStatus(this.task.id, this.taskCompleted).subscribe(task => {
      // this.task = task
    }, error => {
      this.taskCompleted = !this.taskCompleted;
    })
  }

  openProject(event: any, projectId: number) {
    event.stopPropagation();

    if (!this.fromProj) {
      let projectWindow = ProjectWindowComponent as any;

      let panelClass = 'project-window-dialog'

      if (this.isMobile || this.isTablet) {
        projectWindow = ProjectInfoComponent
        panelClass = 'project-info-dialog'
      }

      const dialogRef = this.dialog.open(projectWindow, {
        data: {
          projectNumber: projectId
        },
        panelClass
      });

      dialogRef.afterClosed().subscribe(result => {
      });
    }
  }

  checkLate() {
    if (!this.task.completed && this.task.deadline) {
      const today = new Date();
      const tempDate = this.task.deadline;

      tempDate.setHours(23, 0, 0, 0);
      if (tempDate.getTime() < today.setHours(0, 0, 0, 0)) {
        this.isLate = true;
      }
    }

  }

  toggleReady(event, checkItem: TaskCheckItem) {
    event.stopPropagation()

    checkItem.ready = !checkItem.ready

    if (checkItem.ready) {
      if (this.task.checkitemsCompleted < this.task.checkitemsTotal) {
        this.task.checkitemsCompleted++;
      }

      if (this.task.checkitemsCompleted === this.task.checkitemsTotal) {
        this.taskCompleted = true;
      }
    } else {

      if (this.task.checkitemsCompleted === this.task.checkitemsTotal) {
        this.emitCollapseOff.emit(this.task.id)

        this.taskCompleted = false;
      }

      if (this.task.checkitemsCompleted > 0) {
        this.task.checkitemsCompleted--;
        checkItem.collapsed = false;
      }
    }

    this.projectService
      .saveCheckItem({
        id: checkItem.id,
        ready: checkItem.ready
      })
      .subscribe(() => {

      }, error => {
        checkItem.ready = !checkItem.ready

        if (checkItem.ready) {
          if (this.task.checkitemsCompleted < this.task.checkitemsTotal) {
            this.task.checkitemsCompleted++;
          }
        } else {
          if (this.task.checkitemsCompleted > 0) {
            this.task.checkitemsCompleted--;
          }
        }
      })

    if (checkItem.ready && this.isMobile && this.serviceDep) {
      this.attachPhoto(checkItem)
    }

  }

  attachPhoto(checkItem: TaskCheckItem) {
    this.confirmationService.confirm({
      header: 'Attach Photo',
      message: `Would you like to attach photo?`,
      dismissableMask: true,
      icon: 'pi pi-paperclip',
      accept: () => {
        const input = this.el.nativeElement.getElementsByClassName('mobile-task-photo-input')[0] as HTMLInputElement
        if (input) {
          event.stopPropagation();

          input.click()
          this.choosenCheckItem = checkItem
        }
      }
    });
  }

  testClick(event) {
    event.stopPropagation();
  }

  onFileSelected(event) {
    const file = event.target.files[0]

    this.trelloService.checkItemLoading$.next(this.choosenCheckItem.id);

    this.trelloService.uploadFile([file], this.choosenCheckItem.id).subscribe(httpEvent => {
      if (httpEvent.type === HttpEventType.Response) {
        const projectFiles = (httpEvent as HttpResponse<ProjectFile[]>).body;
        this.choosenCheckItem.files = this.choosenCheckItem.files.concat(projectFiles)
        this.trelloService.checkItemLoading$.next(-1)
      }
    }, error => {
      this.trelloService.checkItemLoading$.next(-1)
    })
  }

  toggleTag(event, tag: CheckItemHeadTag) {
    event.stopPropagation();

    if (tag.name === 'Amount' && !this.currentUser.adminNSuperV) {

    } else {
      tag.ready = !tag.ready
      this.trelloService
        .toggleTag({
          id: tag.id,
          ready: tag.ready
        })
        .subscribe(() => {
        }, error => {
          tag.ready = !tag.ready
        })
    }

  }

  openTaskFile(event, photoId: number) {
    event.stopPropagation()

    const tempFiles: ProjectFile[] = []

    this.task.photoIds.forEach(id => {
      tempFiles.push({
        id,
        name: 'Task File',
        ext: 'png'
      })
    })
    tempFiles.push()

    this.fileOpenerService.openFile({
      id: photoId,
      name: 'Task File',
      ext: 'png'
    }, tempFiles, true)
  }

  openCheckItemFile(event, projectFile: ProjectFile, checkItem: TaskCheckItem) {
    event.stopPropagation()
    this.fileOpenerService.openFile(projectFile, checkItem.files, true)
  }

  toggleCheckItemOrder(event, checkItem: TaskCheckItem) {
    event.stopPropagation();
    checkItem.workOrder = !checkItem.workOrder;
    this.workOrderToggle.emit({checkItem, selected: checkItem.workOrder});
  }

  toggleCollapse(event) {
    event.stopPropagation();
    this.isCollapsed = !this.isCollapsed;
    this.collapseToggle.emit();
  }

  isCollapsedByDefault(): boolean {
    if (this.projectTask)
      return this.task.checkitemsTotal > 2 && this.task.checkitemsCompleted >= this.task.checkitemsTotal
    else
      return this.task.checkitemsTotal > 1
  }

  getUnsubFromAllSubs(): Subject<boolean> {
    return null
  }

  ngOnDestroy() {
    if (this.wsSub) {
      this.wsSub.unsubscribe()
      this.wsSub = null;
    }
  }

}
